module.exports = __webpack_public_path__ + "static/media/schedule_structure_add_a_period.25d457b3.mov";